module.exports = __webpack_public_path__ + "static/img/9en.f80e914.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme/light/desc/02keepAlive/oppo/9en.png
// module id = s9/m
// module chunks = 0